var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcButton',{staticClass:"shape-rect-c",class:_vm.buttonClass,style:(_vm.style),attrs:{"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }